/*
  CHIQ beweging (Nick 26-10, voorbeeld Rhode, register TH19): koppen en kaarten schuiven zacht omhoog als ze in beeld
  komen, kaarten in een rij een voor een; grote beelden bewegen licht mee met scrollen; vinkjes in de vergelijking
  poppen. Alleen elementen die bij het laden nog buiten beeld staan worden verborgen, dus niets knippert of blijft weg.
  Geen beweging bij prefers-reduced-motion of zonder IntersectionObserver.
  Bron: Ecompagnon/CHIQ-Cosmetics store/theme-src.
*/
(function () {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var HEADS = '.chiq-ps__head, .chiq-cs__head, .chiq-jr__head, .chiq-hw__head, .chiq-cmp__head, .chiq-pr__head, .chiq-nt__head, .chiq-tf__head, .chiq-faq__title, .chiq-ki__intro, .chiq-bd__inner, .chiq-cp__head';
  var ITEMS = '.chiq-ps__item, .chiq-cs__item, .chiq-jr__item, .chiq-pr__item, .chiq-faq__item, .chiq-tf__card, .chiq-nt__card, .chiq-cmp__row, .chiq-cu__item';
  var PARALLAX = '.chiq-bd__img';

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('chiq-m--in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  function prepare(el, delay) {
    if (el.dataset.chiqM) return;
    el.dataset.chiqM = '1';
    if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return; // al in beeld: niet verbergen
    el.style.setProperty('--chiq-d', delay + 's');
    el.classList.add('chiq-m');
    io.observe(el);
  }

  function init(root) {
    root.querySelectorAll(HEADS).forEach(function (el) { prepare(el, 0); });
    root.querySelectorAll(ITEMS).forEach(function (el) {
      // kaarten in een horizontale slider niet los verbergen: wat rechts buiten beeld staat zou dan onzichtbaar blijven
      // (geen 'peek' van de volgende kaart). Dan schuift de hele rij in een keer in.
      var ox = getComputedStyle(el.parentElement).overflowX;
      if (ox === 'auto' || ox === 'scroll') { prepare(el.parentElement, 0); el.dataset.chiqM = '1'; return; }
      var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(ITEMS); });
      prepare(el, Math.min(sibs.indexOf(el), 7) * 0.08);
    });
  }

  // lichte parallax op grote beelden: het beeld schuift max ~6% binnen zijn kader
  var plx = [];
  function initParallax(root) {
    root.querySelectorAll(PARALLAX).forEach(function (img) { if (plx.indexOf(img) < 0) { img.classList.add('chiq-plx'); plx.push(img); } });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      plx.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2); // -1..1
        img.style.setProperty('--chiq-plx', (p * -6).toFixed(2) + '%');
      });
      ticking = false;
    });
  }

  // productkaarten (Rhode): video speelt bij hover met een muis, stopt en spoelt terug bij weggaan
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseover', function (e) {
      var c = e.target.closest && e.target.closest('.chiq-ps__card'); if (!c || c.contains(e.relatedTarget)) return;
      var v = c.querySelector('.chiq-ps__vid'); if (!v) return;
      v.preload = 'auto'; c.classList.add('is-playing'); v.play().catch(function () {});
    });
    document.addEventListener('mouseout', function (e) {
      var c = e.target.closest && e.target.closest('.chiq-ps__card'); if (!c || c.contains(e.relatedTarget)) return;
      var v = c.querySelector('.chiq-ps__vid'); if (!v) return;
      c.classList.remove('is-playing'); v.pause(); v.currentTime = 0;
    });
  }

  function boot() { init(document); initParallax(document); onScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initParallax(e.target); });
  // cart drawer wordt opnieuw gerenderd: nieuwe upsell-kaarten niet verbergen
  document.addEventListener('cart:update', function () { setTimeout(function () { document.querySelectorAll('.chiq-cu__item').forEach(function (el) { el.dataset.chiqM = '1'; }); }, 50); });
})();
